import React from "react"
import AboutBanner from "@components/layouts/about/AboutBanner/AboutBanner"
import AboutFoundingStory from "@components/layouts/about/AboutFoundingStory/AboutFoundingStory"
import AboutGallery from "@components/layouts/about/AboutGallery/AboutGallery"
import AboutIntro from "@components/layouts/about/AboutIntro/AboutIntro"
import AboutStory from "@components/layouts/about/AboutStory/AboutStory"
import AboutValues from "@components/layouts/about/AboutValues/AboutValues"
import * as styles from "./About.module.scss"

const About = (props) => (
  <main className={styles.About}>
    <AboutIntro title={props.title} subtitle={props.subtitle} intro={props.intro} />
    <AboutGallery gallery={props.gallery} />
    <AboutStory ourStory={props.ourStory} />
    <AboutValues ourValues={props.ourValues} />
    <AboutBanner banner={props.banner} />
    <AboutFoundingStory foundingStory={props.foundingStory} team={props.team} />
  </main>
)

export default About
